
import axios from 'axios';

import API_URL from '../../config';

export const PublicService = {
    /**
     * Consulta deudas pendientes de un cliente de forma pública
     * @param {string} codigoMedidor 
     * @param {string} cedula 
     */
    async consultarDeuda(codigoMedidor, cedula) {
        try {
            const response = await axios.get(`${API_URL}/api/v2/public/consultar-deuda`, {
                params: { codigoMedidor, cedula }
            });
            return response.data;
        } catch (error) {
            console.error('Error en PublicService:', error);
            throw error.response?.data?.error || 'Error al realizar la consulta. Verifique sus datos.';
        }
    }
};
